import ReferralBySourceModule from "./ReferralBySourceModule";
import ReferralsSaga from "../../redux/sagas/referrals";
import ReferralBySourceReducer from "../../redux/reducers/referralBySource";

export default {
  Component: ReferralBySourceModule,
  moduleName: "referralBySource",
  saga: ReferralsSaga("referralBySource"),
  reducer: ReferralBySourceReducer
};
